<template>
  <div>
      <v-toolbar color="#000000" dark dense>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn class="button_font" flat to="/dashboard">  <v-icon right dark class="pr-2">account_balance</v-icon> Dashboard</v-btn>
        
          <v-btn class="button_font" flat to="/profile"><v-icon right dark class="pr-2">account_box</v-icon> My Profile</v-btn>
            <v-btn class="button_font" flat @click="openSub = true"><v-icon right dark class="pr-2">edit</v-icon> New Submission</v-btn>
          <v-btn class="button_font" flat @click="logout"><v-icon right dark class="pr-2">exit_to_app</v-icon> Logout</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-dialog
        v-model="openSub"
        v-if="openSub"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
      <v-card tile>
          <v-toolbar
            flat
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="openSub = false"
            >
            X
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
      
          <SubForm @closeDialog="openSub = false"/>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import SubForm from './SubForm.vue'
export default {
  components: {
    SubForm
  },
  data() {
    return {
      openSub: false
    };
  },
  methods:{
    logout(){
      localStorage.clear()
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>

.button_font {
  font-weight:bold;
}
</style>